export const WAYPOINT_OUTLINE_ICON_IMAGE_ID = 'rt-waypoint-outline-icon';

const _ICON_SIZE_PX = 24;

// "Configured but not yet in use" waypoint — outline-only amber diamond
// with a hollow centre. Rendered for the currently-selected barrier's
// `auto_waypoints` so the user can see where detours WOULD go before
// any route actually exercises them. The solid version
// (`WAYPOINT_ICON_IMAGE_ID`) stays reserved for detours produced by
// existing routes.
const _WAYPOINT_OUTLINE_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="${_ICON_SIZE_PX}" height="${_ICON_SIZE_PX}" viewBox="0 0 24 24">
  <path d="M12 1.2 L22.8 12 L12 22.8 L1.2 12 Z" fill="#ffffff" fill-opacity="0.85" stroke="#fa8c16" stroke-width="2.2" stroke-linejoin="round"/>
  <circle cx="12" cy="12" r="2.2" fill="#fa8c16"/>
</svg>
`.trim();

export function buildWaypointOutlineIconDataUrl(): string {
  const encoded = encodeURIComponent(_WAYPOINT_OUTLINE_SVG);
  return `data:image/svg+xml;charset=utf-8,${encoded}`;
}

export function loadWaypointOutlineIconImage(): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image(_ICON_SIZE_PX, _ICON_SIZE_PX);
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('failed to load waypoint outline icon'));
    img.src = buildWaypointOutlineIconDataUrl();
  });
}
